import axios from 'axios';
import type { InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { Message } from '@arco-design/web-vue';
import { getCookie } from '@/utils';
import { toCamelCase, toSnakeCase } from '@/utils/transformCase';
import queryString from 'query-string';
import { goSSO } from '@/utils/auth';

export interface HttpResponse<T = unknown> {
  msg: string;
  code: number;
  data: T;
}

const whiteList = ['/bi/api/reports/data'];
axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getCookie('biUserToken');

    if (token && !config.url?.includes('admarket.youxi123.com/')) {
      config.headers.Authorization = `${token}`;
    }
    if (config.data && typeof config.data === 'object') {
      config.data = toSnakeCase(config.data);
    }
    if (config.data && typeof config.data === 'string') {
      config.data = queryString.stringify(
        toSnakeCase(queryString.parse(config.data))
      );
    }
    if (config.params && typeof config.params === 'object') {
      config.params = toSnakeCase(config.params);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 修改响应拦截器
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.data && !whiteList.includes(response.config.url as string)) {
      response.data = toCamelCase(response.data);
    }
    const res = response.data;
    if (res.code !== 0) {
      // 处理特定的错误码
      if (res.code === 401) {
        // 401：Token无效或已过期，跳转到bi登录页面
        goSSO();
      } else if (res.code !== 0) {
        Message.error({ content: res.msg.slice(0, 100), id: 'responseError' });
      }
      return Promise.reject(res);
    }
    return res;
  },
  error => {
    // 如果是网络错误或服务器错误，也跳转到登录页面
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      goSSO();
    }
    Message.error({
      content: error.message + ':' + error?.response?.data?.msg?.slice(0, 100),
      id: 'responseError'
    });
    return Promise.reject(error);
  }
);

export default axios;
